<script>
import { Component, Vue } from 'vue-property-decorator'
import VueQrcode from '@xkeshi/vue-qrcode'
import customerImg from "@/assets/img/customer.png";
@Component({
  components: {
    VueQrcode
  },
  props: {
    visible: {
      default: true,
      type: Boolean
    }
  }
})
export default class Qrcode extends Vue {
  render() {
    return (
      <div class="qrcode">
        <img src={customerImg} width={124} height={124} />
        {this.visible && (
          <div class="qrcode-text">
            扫码联系客服
          </div>
        )}
      </div>
    )
  }
}
</script>

<style lang="postcss">
.qrcode {
  padding: 10px 8px;
  background-color: #fff;
  &-text {
    font-size: 14px;
    color: #21a2f2;
    margin-top: 10px;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/public/Qrcode.vue